import { render, staticRenderFns } from "./SecurityOtherDevice.vue?vue&type=template&id=12c107bc&scoped=true&"
import script from "./SecurityOtherDevice.vue?vue&type=script&lang=js&"
export * from "./SecurityOtherDevice.vue?vue&type=script&lang=js&"
import style0 from "./SecurityOtherDevice.vue?vue&type=style&index=0&id=12c107bc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12c107bc",
  null
  
)

export default component.exports